import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Mechanism() {
  return <section className="py-16 md:py-24 bg-brand-sage text-white relative overflow-hidden" data-id="element-94">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-95">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-96"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-97"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10 text-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-99">
          <div className="inline-flex items-center justify-center p-3 bg-white/20 rounded-full mb-6 backdrop-blur-sm" data-id="element-100">
            <Sparkles className="w-8 h-8 text-white" data-id="element-101" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-102">
            El Protocolo de Regulación Estrógeno-Cortisol
          </h2>
          <div className="space-y-6 text-lg md:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto" data-id="element-103">
            <p data-id="element-104">
              Este no es un plan de pérdida de peso tradicional. Es un sistema
              de{' '}
              <span className="font-bold text-white" data-id="element-105">
                "reajuste de señales"
              </span>
              .
            </p>
            <p data-id="element-106">
              En lugar de forzar a tu cuerpo a perder grasa, le enseñamos que es
              seguro liberarla.
            </p>
            <p className="font-medium text-white text-xl md:text-2xl mt-8" data-id="element-107">
              Al estabilizar la insulina y calmar el cortisol, el interruptor de
              tu metabolismo vuelve a encenderse de forma natural.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}